import { render, staticRenderFns } from "./KetuntasanA1Program.vue?vue&type=template&id=43a8df60&scoped=true&"
import script from "./KetuntasanA1Program.vue?vue&type=script&lang=js&"
export * from "./KetuntasanA1Program.vue?vue&type=script&lang=js&"
import style0 from "./KetuntasanA1Program.vue?vue&type=style&index=0&id=43a8df60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a8df60",
  null
  
)

export default component.exports